export enum CompaniesStatusFilter {
    All = 'All',
    UnderReview = 'UnderReview',
    Rejected = 'Rejected',
    Active = 'Active'
}